module.exports = __webpack_public_path__ + "img/system32-details.dc9c4d9d.png";